export const furnitureAnchorSides = ['BOTTOM', 'RIGHT', 'TOP', 'LEFT']